<template>
  <div class="wrapper">
    <AlertModal />
    <PointGroupCatalogBreadCrumb class="breadCrumb" />
    <Section>
      <template>
        <OEM
          :systemOwner="systemOwner"
          :selectedPointGroup="selectedPointGroup"
          class="oem"
        />
      </template>
      <template>
        <Advertiser
          :advertiser="advertiser"
          :agencyId="agencyId"
          class="advertiser"
        />
      </template>
      <template v-if="IOList">
        <IOList
          :IOListData="IOList"
          :agencyId="agencyId"
          :selectedPointGroup="selectedPointGroup"
        />
      </template>
    </Section>
  </div>
</template>

<script>
import PointGroupCatalogAPI from '@/api/PointGroup/PointGroupCatalog'
import OEM from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/OEM/OEM'
import Advertiser from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/Advertiser/Advertiser'
import IOList from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/IO/IOList'
import AlertModal from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/AlertModal'
import PointGroupCatalogBreadCrumb from '@/components/Shared/BreadCrumb/PointGroupCatalogBreadCrumb'
import Section from '@/components/Shared/Section/Section'

import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'
import {
  getters as pointGroupCatalogGetters,
  actions as pointGroupCatalogActions,
} from '@/vuex/modules/pointGroupCatalog/constants'

export default {
  name: 'PointGroupCatalog',
  components: {
    OEM,
    Advertiser,
    IOList,
    PointGroupCatalogBreadCrumb,
    AlertModal,
    Section,
  },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
  ],
  data() {
    return {
      IOList: [],
      advertiser: {},
      systemOwner: {},
    }
  },
  computed: {
    advertiserId() {
      return parseInt(this.$route.params.advertiserId)
    },
    agencyId() {
      return parseInt(this.$route.params.agencyId)
    },
    selectedPointGroup() {
      return this.$store.getters[pointGroupCatalogGetters.selecetedPointGroup]
    },
  },
  async created() {
    this.IOList = await PointGroupCatalogAPI.getIOList(this.advertiserId)
    this.advertiser = await PointGroupCatalogAPI.getAdvertiser(
      this.advertiserId,
    )
    this.systemOwner = await PointGroupCatalogAPI.getSystemOwner()
  },
  destroyed() {
    this.$store.dispatch(pointGroupCatalogActions.RESET_POINT_GROUP_LIST)
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
.breadCrumb {
  margin-bottom: 20px;
}
.advertiser {
  margin-bottom: 8px;
}
.oem {
  margin-bottom: 8px;
}
</style>
